// extracted by mini-css-extract-plugin
module.exports = {"megaMenuCms":"MegaMenu_megaMenuCms__5k0_O","burgerIcon":"MegaMenu_burgerIcon__QFHVs","activeBurger":"MegaMenu_activeBurger__6hdP_"};